import Swiper from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';

document.querySelectorAll('.list-testimonials--slider').forEach((el) => {
  const swiper = new Swiper(el, {
    modules: [EffectFade, Autoplay],
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    grabCursor: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  // const parent = el.parentElement;
  // if (!parent) return;

  // parent.querySelector('.slider--arrow.next')?.addEventListener('click', () => swiper.slideNext());
  // parent.querySelector('.slider--arrow.prev')?.addEventListener('click', () => swiper.slidePrev());
});
